// extracted by mini-css-extract-plugin
export default {"Registration":"Registration_Registration__yktwZ"};